module.exports = __webpack_public_path__ + "media/no_available_admins.bd2b5065.mp3";